import { createApiHandler } from './handler';

const breeds = {
  apiClient: null,
  path: '/admin/breeds',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getDogs(params) {
    try {
      const queryParams = new URLSearchParams();

      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });

      const response = await this.apiClient.get(`${this.path}/dogs?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getCats(params) {
    try {
      const queryParams = new URLSearchParams();
      
      params.forEach(param => {
        if (param.name && param.value) {
          queryParams.append(param.name, param.value);
        }
      });
      
      const response = await this.apiClient.get(`${this.path}/cats?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default breeds;
